import { registerSvelte, globToComponents } from "../lib/registerSvelte.svelte"
import "../lib/devtools"

const svelteImports = globToComponents(import.meta.glob("../components/for_pages/*.svelte", {eager: false}))
registerSvelte(svelteImports)
